module.exports = __webpack_public_path__ + "static/media/ferrero.3664a085.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ferrero.jpg
// module id = 841
// module chunks = 6